import {useUyo} from '~/common/fabric/Card/hooks/useUyo';

export const useUyoValidation = () => {
  const {isUyo, pristineUyo} = useUyo();

  const validate = () => {
    if (isUyo && pristineUyo) {
      return {
        error: true,
        title: 'Missing photo',
        message: 'Please upload a photo to your invitation design.',
      };
    }
  };

  return {validate};
};
